exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-m-select[data-v-2022fd25] {\n  width: 100%;\n}\n.wl-overflow-tooltip[data-v-2022fd25] {\n  overflow: hidden;\n  display: inline-block;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.select-item-cls[data-v-2022fd25] {\n  width: 0.677083rem;\n}\n.select-item-cls2[data-v-2022fd25] {\n  width: 0.78125rem;\n}", ""]);

// exports
